import { AxiosInstanceProvider } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { SlaMonitoredServicesHttpQuery } from '../../config';
import { SlaMetricsMeasurementApiModel } from '../../model';

export interface SlaMetricsMeasurementHttpGetPayloadModel {
  customerId: number;
  itemId: number;
  cosId: number;
  chartSettings: ChartSettings;
}

export type SlaMetricsMeasurementHttpGetResponseModel = SlaMetricsMeasurementApiModel[];

export const getSlaMetricsMeasurement = async (
  axios: AxiosInstanceProvider,
  { customerId, cosId, itemId, chartSettings }: SlaMetricsMeasurementHttpGetPayloadModel,
): Promise<SlaMetricsMeasurementHttpGetResponseModel> => {
  const response = await axios().get<SlaMetricsMeasurementHttpGetResponseModel>(
    SlaMonitoredServicesHttpQuery['GetSlaMetricsMeasurement'].url
      .replace('{customerId}', customerId.toString(10))
      .replace('{itemId}', itemId.toString(10))
      .replace('{cosId}', cosId.toString(10)),
    { params: { timespan: chartSettings.timespan, resolution: chartSettings.resolution } },
  );

  return response.data;
};
